import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = ({ fill, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={fill || "currentColor"}
      fillRule="evenodd"
      d="M0 5a3 3 0 0 1 3-3h18a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V5Zm7.784 15H21a1 1 0 0 0 1-1v-6.026l-3.675-3.007a1 1 0 0 0-1.368.096L7.784 20ZM22 10.39V5a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v4.586l1.977 1.977c.26-.417.618-.83 1.041-1.195C5.872 9.631 7.095 9 8.5 9c1.405 0 2.628.63 3.482 1.368.386.333.717.706.97 1.085l2.535-2.747a3 3 0 0 1 4.104-.287L22 10.39Zm-10.5 2.635a1.06 1.06 0 0 1 0-.027c-.005-.022-.031-.146-.165-.364a3.368 3.368 0 0 0-.66-.752C10.08 11.369 9.305 11 8.5 11c-.804 0-1.58.37-2.175.882-.293.253-.516.52-.66.752-.134.218-.16.341-.164.364a1.01 1.01 0 0 1-.004.085l3.094 3.094 2.91-3.152Zm-4.266 4.623L5.062 20H3a1 1 0 0 1-1-1v-6.586l5.234 5.234Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgComponent;
